import { ALREADY_LOADED_ICON_URLS } from './loaded-icons';
import { MAPPINGS } from './mappings';

export const ConstantsIcons = {
  MAPPINGS,
  ALREADY_LOADED_ICON_URLS
};
